document.addEventListener('DOMContentLoaded', function () {
    // Function to check if the element with class "rc-container-wrapper rc_container_wrapper" exists
    function checkElement() {
        var rcContainer = document.querySelector('.rc-container-wrapper.rc_container_wrapper');

        // If the element exists, hide ".price__container"
        if (rcContainer) {
            var priceContainer = document.querySelector('.price__container');
            priceContainer.style.visibility = 'visible';
        } else {
            // If not, wait and check again after a short delay
            setTimeout(checkElement, 100);
        }
    }

    // Call the function initially
    checkElement();
});